import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import reducer from "./reducers";

const combinedReducer = combineReducers({
  ...reducer,
});
/**
 * The root state type of the Redux store.
 * @type {ReturnType<typeof store.getState>}
 */
export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === "logout") {
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

/**
 * The type of the dispatch function in the Redux store.
 * @type {typeof store.dispatch}
 */
export type AppDispatch = typeof store.dispatch;
